<div class="card-wrapper">
  <mat-card *ngIf="article" class="article-card" appearance="outlined">
    <div class="card-content-flex">
      <div class="image-container">
        <img *ngIf="article.foto" mat-card-image [src]="article.foto.url" [alt]="article.foto.alt || article.title" />
      </div>

      <div class="card-text">
        <mat-card-header>
          <mat-card-title>
            <h3>{{ article.title }}</h3>
          </mat-card-title>
          <!--<mat-card-subtitle>{{ article.createdAt | date }}</mat-card-subtitle>-->
        </mat-card-header>
        <mat-card-content>
          <p>{{ article.description }}</p>
          <section class="article-info">
            <div class="author">
              <img [src]="article.author.profileImgUrl">
              <p>{{ article.author.name }}</p>
            </div>
            <div class="example-spacer"></div>
            <button *ngIf="auth.isEditor()" mat-flat-button style="background-color: transparent;" disabled>
              <mat-icon>visibility</mat-icon>
              {{ article.views }}
            </button>
            <button mat-flat-button style="background-color: transparent;" disabled>
              <mat-icon>thumb_up</mat-icon>
              {{ article.likes }}
            </button>
          </section>
        </mat-card-content>
      </div>
    </div>
  </mat-card>
</div>